module.exports = __webpack_public_path__ + "img/icon-type-pdf.73d3ec28.svg";